const REVISION_MESSAGE = 'The battlefield changed before this action could finish. No action or damage was applied. Review the board and try again.';

/**
 * Keep server diagnostics in logs while presenting recovery steps in play.
 * Raw schema paths, entity IDs, and architecture references are developer
 * details and must not become the primary BattleRoom message.
 * date_of_change: 2026-09-08
 */
export const getRealtimeMutationFeedback = (errorLike, { actionName = '' } = {}) => {
  const code = String(errorLike?.code || errorLike?.response?.code || '');
  const technicalMessage = String(errorLike?.message || errorLike?.response?.message || '');
  const actionLabel = String(actionName || '').trim();

  if (code === 'REVISION_CONFLICT' || /resolutionRevision|authoritative revision/i.test(technicalMessage)) {
    return {
      title: 'BattleRoom updated',
      message: REVISION_MESSAGE,
    };
  }

  if (code === 'TOKEN_CONTROL_REQUIRED') {
    return {
      title: 'Control required',
      message: 'Choose a creature you control, then try the action again. No changes were applied.',
    };
  }

  if (code === 'SESSION_NOT_JOINED' || code === 'SESSION_NOT_FOUND' || code === 'SESSION_DISCONNECTED') {
    return {
      title: 'Reconnect to continue',
      message: 'The BattleRoom connection was interrupted. Reconnect, review the board, and try again.',
    };
  }

  if (code === 'AUTHORITATIVE_PROJECTION_TIMEOUT' || code === 'BATTLE_ROOM_NOT_READY') {
    return {
      title: 'BattleRoom still syncing',
      message: 'The latest battlefield changes are still loading. Wait a moment, then try the action again.',
    };
  }

  if (code === 'CREATURE_ACTION_REJECTED') {
    return {
      title: 'Action not completed',
      message: `${actionLabel ? `${actionLabel} c` : 'C'}ould not be completed from the current battlefield state. No action or damage was applied. Review the current turn and try again.`,
    };
  }

  return {
    title: 'Change not saved',
    message: 'That change could not be completed. The BattleRoom was left unchanged. Review the board and try again.',
  };
};

export default getRealtimeMutationFeedback;
